class RouteFront {
    constructor({
        routeId = null,
        companyId = null,
        name = null,
        description = null,
        value = null,
        text = null,
        isnew = false,
    }) {
        this.routeId = routeId;
        this.companyId = companyId;
        this.name = name;
        this.description = description;
        this.value = value;
        this.text = text;
        this.isnew = isnew;
    }
}

class RouteBack {
    constructor({
        routeId = routeId,
        companyId = companyId,
        name = name,
        description = description,
        value = value,
        text = text,
        isnew = isnew
    }) {
        this.routeId = routeId;
        this.companyId = companyId;
        this.name = name;
        this.description = description;
        this.value = value;
        this.text = text;
        this.isnew = isnew;
    }
}

export { RouteFront, RouteBack }